import { getBooksPk } from "@services/books";
import { putUsers } from "@services/account/user";
import {
    getPageProfile,
    postPageProfile,
    putPageProfile,
    deletePageProfile,
} from "@services/page-profile";
import deepClone from "deep-clone";
import i18n from "@/i18n";

const state = {
    settings: [
        { alert: "fastTrade", width: 9, height: 300, posX: 0, posY: 0 },
        { alert: "largeExposure", width: 9, height: 300, posX: 9, posY: 0 },
        { alert: "largeVolume", width: 9, height: 300, posX: 18, posY: 0 },
        { alert: "largeVolumeUSD", width: 9, height: 300, posX: 27, posY: 600 },
        { alert: "lockingPosition", width: 9, height: 300, posX: 0, posY: 300 },
        { alert: "mandate", width: 9, height: 300, posX: 9, posY: 300 },
        { alert: "profitTaker", width: 9, height: 300, posX: 18, posY: 300 },
        { alert: "tradeOnCredit", width: 9, height: 300, posX: 27, posY: 0 },
        { alert: "watchList", width: 9, height: 300, posX: 0, posY: 600 },
        { alert: "dailyWinner", width: 9, height: 300, posX: 9, posY: 600 },
        { alert: "dailyLoser", width: 9, height: 300, posX: 18, posY: 600 },
        {
            alert: "largeExposureVolume",
            width: 9,
            height: 300,
            posX: 27,
            posY: 300,
        },
        {
            alert: "depositWithdrawal",
            width: 9,
            height: 300,
            posX: 0,
            posY: 900,
        },
        { alert: "sameDirection", width: 9, height: 300, posX: 9, posY: 900 },
        { alert: "timeDecay", width: 9, height: 300, posX: 18, posY: 900 },
        { alert: "tick", width: 9, height: 300, posX: 27, posY: 900 },
        { alert: "highVolumeUSD", width: 9, height: 300, posX: 0, posY: 1200 },
        { alert: "highTrades", width: 9, height: 300, posX: 9, posY: 1200 },
        { alert: "largePNL", width: 9, height: 300, posX: 18, posY: 1200 },
        {
            alert: "lowLiquidityArbitrage",
            width: 9,
            height: 300,
            posX: 27,
            posY: 1200,
        },
    ],
    allAlertOptions: {
        fastTrade: {
            name: i18n.t("profile.alert.FastTrade"),
            value: "fastTrade",
        },
        largeVolume: {
            name: i18n.t("profile.alert.LargeVolume"),
            value: "largeVolume",
        },
        largeVolumeUSD: {
            name: i18n.t("profile.alert.LargeVolumeUSD"),
            value: "largeVolumeUSD",
        },
        lockingPosition: {
            name: i18n.t("profile.alert.LockingPosition"),
            value: "lockingPosition",
        },
        profitTaker: {
            name: i18n.t("profile.alert.ProfitTaker"),
            value: "profitTaker",
        },
        tradeOnCredit: {
            name: i18n.t("profile.alert.TradeOnCredit"),
            value: "tradeOnCredit",
        },
        watchList: {
            name: i18n.t("profile.alert.WatchList"),
            value: "watchList",
        },
        dailyWinner: {
            name: i18n.t("profile.alert.DailyWinner"),
            value: "dailyWinner",
        },
        dailyLoser: {
            name: i18n.t("profile.alert.DailyLoser"),
            value: "dailyLoser",
        },
        largeExposureVolume: {
            name: i18n.t("profile.alert.LargeExposureVolume"),
            value: "largeExposureVolume",
        },
        depositWithdrawal: {
            name: i18n.t("profile.alert.DepositWithdrawal"),
            value: "depositWithdrawal",
        },
        sameDirection: {
            name: i18n.t("profile.alert.SameDirection"),
            value: "sameDirection",
        },
        timeDecay: {
            name: i18n.t("profile.alert.TimeDecay"),
            value: "timeDecay",
        },
        highVolumeUSD: {
            name: i18n.t("profile.alert.HighVolumeUSD"),
            value: "highVolumeUSD",
        },
        highTrades: {
            name: i18n.t("profile.alert.HighTrades"),
            value: "highTrades",
        },
        largePNL: {
            name: i18n.t("profile.alert.LargePNL"),
            value: "largePNL",
        },
        lowLiquidityArbitrage: {
            name: i18n.t("profile.alert.LowLiquidityArbitrage"),
            value: "lowLiquidityArbitrage",
        },
    },
    clickedOutside: false,
    allProfile: [],
    selectedProfile: { id: 0 },
    editingDialog: null,
    updated: false,
    loading: false,
    isBtnDisabled: true,
    lastAddition: null,
    defaultSetting: {
        settings: {
            fastTrade: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                volume: {
                    text: i18n.t("common.table.volume"),
                    showing: true,
                },
                symbol: {
                    text: i18n.t("common.table.symbol"),
                    showing: true,
                },
                duration: {
                    text: i18n.t("common.table.duration"),
                    showing: true,
                },
                book_a: {
                    text: "Book",
                    showing: true,
                },
            },
            largeVolume: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                symbol: {
                    text: i18n.t("common.table.symbol"),
                    showing: true,
                },
                volume: {
                    text: i18n.t("common.table.volume"),
                    showing: true,
                },
                open_time: {
                    text: i18n.t("common.table.openTime"),
                    showing: true,
                },
                close_time: {
                    text: i18n.t("common.table.closeTime"),
                    showing: true,
                },
                action: {
                    text: i18n.t("common.table.action"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
            },
            largeVolumeUSD: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                symbol: {
                    text: i18n.t("common.table.symbol"),
                    showing: true,
                },
                volumeUSD: {
                    text: i18n.t("common.table.volumeUSD"),
                    showing: true,
                },
                open_time: {
                    text: i18n.t("common.table.openTime"),
                    showing: true,
                },
                close_time: {
                    text: i18n.t("common.table.closeTime"),
                    showing: true,
                },
                action: {
                    text: i18n.t("common.table.action"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
                pnl: {
                    text: i18n.t("common.table.pnl"),
                    showing: true,
                },
                lot: {
                    text: i18n.t("common.table.lot"),
                    showing: true,
                },
                direction: {
                    text: i18n.t("common.table.direction"),
                    showing: true,
                },
            },
            lockingPosition: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                symbol: {
                    text: i18n.t("common.table.symbol"),
                    showing: true,
                },
                locking_position: {
                    text: i18n.t("common.table.lockingPos"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
            },
            profitTaker: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                symbol: {
                    text: i18n.t("common.table.symbol"),
                    showing: true,
                },
                profit_closed_eod: {
                    text: i18n.t("common.table.profitEOD"),
                    showing: true,
                },
                trigger_time: {
                    text: i18n.t("common.table.triggerTime"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
            },
            tradeOnCredit: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                equity: {
                    text: i18n.t("common.table.equity"),
                    showing: true,
                },
                balance: {
                    text: i18n.t("common.table.balance"),
                    showing: true,
                },
                credit: {
                    text: i18n.t("common.table.credit"),
                    showing: true,
                },
                trigger_time: {
                    text: i18n.t("common.table.triggerTime"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
            },
            watchList: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                volume: {
                    text: i18n.t("common.table.volume"),
                    showing: true,
                },
                symbol: {
                    text: i18n.t("common.table.symbol"),
                    showing: true,
                },
                open_price: {
                    text: i18n.t("common.table.openPrice"),
                    showing: true,
                },
                close_price: {
                    text: i18n.t("common.table.closePrice"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
            },
            dailyWinner: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                closed_profit_eod: {
                    text: i18n.t("common.table.closedProfitEODWinner"),
                    showing: true,
                },
                NetProfitEOD: {
                    text: i18n.t("common.table.dailyNet"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
            },
            dailyLoser: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                closed_profit_eod: {
                    text: i18n.t("common.table.closedProfitEODLoser"),
                    showing: true,
                },
                NetProfitEOD: {
                    text: i18n.t("common.table.dailyNet"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
            },
            largeExposureVolume: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                symbol: {
                    text: i18n.t("common.table.symbol"),
                    showing: true,
                },
                exposureVolume: {
                    text: i18n.t("common.table.volume"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
            },
            depositWithdrawal: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                amount: {
                    text: i18n.t("common.table.amount"),
                    showing: true,
                },
                trigger_time: {
                    text: i18n.t("common.table.triggerTime"),
                    showing: true,
                },
                action: {
                    text: i18n.t("common.table.action"),
                    showing: true,
                },
                book_name: {
                    text: "Book",
                    showing: true,
                },
            },
            sameDirection: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                symbol: {
                    text: i18n.t("common.table.symbol"),
                    showing: true,
                },
                book: {
                    text: "Book",
                    showing: true,
                },
                total_volume: {
                    text: i18n.t("common.table.volume"),
                    showing: true,
                },
                order: {
                    text: i18n.t("common.table.order"),
                    showing: true,
                },
                trigger_time: {
                    text: i18n.t("common.table.triggerTime"),
                    showing: true,
                },
                event: {
                    text: i18n.t("common.table.event"),
                    showing: true,
                },
            },
            highVolumeUSD: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
                ccy: {
                    text: i18n.t("common.table.ccy"),
                    showing: true,
                },
                today_open_volume_usd: {
                    text: i18n.t("common.table.today_open_volume_usd"),
                    showing: true,
                },
                most_today_opened_volume_usd_symbol: {
                    text: i18n.t(
                        "common.table.most_today_opened_volume_usd_symbol"
                    ),
                    showing: true,
                },
                today_open_trades_profit: {
                    text: i18n.t("common.table.today_open_trades_profit"),
                    showing: true,
                },
                trigger_time: {
                    text: i18n.t("common.table.trigger_time"),
                    showing: true,
                },
            },
            highTrades: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
                ccy: {
                    text: i18n.t("common.table.ccy"),
                    showing: true,
                },
                today_open_trade_count: {
                    text: i18n.t("common.table.today_open_trade_count"),
                    showing: true,
                },
                most_opened_symbol: {
                    text: i18n.t("common.table.most_opened_symbol"),
                    showing: true,
                },
                today_open_trades_profit: {
                    text: i18n.t("common.table.today_open_trades_profit"),
                    showing: true,
                },
                trigger_time: {
                    text: i18n.t("common.table.trigger_time"),
                    showing: true,
                },
            },
            largePNL: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
                ccy: {
                    text: i18n.t("common.table.ccy"),
                    showing: true,
                },
                today_open_trades_profit: {
                    text: i18n.t("common.table.today_open_trades_profit"),
                    showing: true,
                },
                top_symbol: {
                    text: i18n.t("common.table.top_symbol"),
                    showing: true,
                },
                trigger_time: {
                    text: i18n.t("common.table.trigger_time"),
                    showing: true,
                },
            },
            lowLiquidityArbitrage: {
                name: {
                    text: i18n.t("common.table.name"),
                    showing: true,
                },
                books: {
                    text: "Book",
                    showing: true,
                },
                ccy: {
                    text: i18n.t("common.table.ccy"),
                    showing: true,
                },
                today_open_trades_profit: {
                    text: i18n.t("common.table.today_open_trades_profit"),
                    showing: true,
                },
                low_liquidity_profit: {
                    text: i18n.t("common.table.low_liquidity_profit"),
                    showing: true,
                },
                top_symbol: {
                    text: i18n.t("common.table.top_symbol"),
                    showing: true,
                },
                trigger_time: {
                    text: i18n.t("common.table.trigger_time"),
                    showing: true,
                },
            },
        },
        unselectedBooks: [],
        unselected: [],
    },
    books: [],
    selectedPeriod: 10,
    periodOptions: [0, 10, 20, 60, 120],
    alertTutorial: false,
    extraIBHeaders: [
        {
            text: "IB",
            value: "partner_id",
            align: "left",
            width: 80,
        },
        {
            text: "Back Office",
            value: "back_office_id",
            align: "left",
            width: 100,
        },
        {
            text: "Customer",
            value: "account_id",
            align: "left",
            width: 100,
        },
    ],
    cleanUpLoading: false,
};

const actions = {
    getProfileAction({ commit }, data) {
        commit("UPDATE_BTN_STATUS", true);
        getPageProfile(data).then((res) => {
            if (res.data.length == 0) {
                commit("UPDATE_ALL_PROFILE", [
                    {
                        id: 0,
                        text: "default",
                        unselected: state.defaultSetting.unselected,
                        settings: state.defaultSetting.settings,
                        unselectedBooks: state.defaultSetting.unselectedBooks,
                        positions: state.settings,
                    },
                ]);
                commit("UPDATE_SELECTED_PROFILE", {
                    id: 0,
                    text: "default",
                    unselected: state.defaultSetting.unselected,
                    settings: state.defaultSetting.settings,
                    unselectedBooks: state.defaultSetting.unselectedBooks,
                    positions: state.settings,
                });
            } else {
                const returnedProfileList = res.data.map((profile) => {
                    return {
                        id: profile.id,
                        text: profile.profile_name,
                        settings: JSON.parse(profile.value).settings,
                        positions:
                            JSON.parse(profile.value).positions == []
                                ? state.settings
                                : JSON.parse(profile.value).positions,
                        unselected: JSON.parse(profile.value).unselected,
                        unselectedBooks: JSON.parse(profile.value)
                            .unselectedBooks,
                    };
                });
                commit("UPDATE_ALL_PROFILE", returnedProfileList);

                const alertId = parseInt(localStorage.getItem("alertId"));
                if (alertId) {
                    if (
                        returnedProfileList.find((item) => item.id === alertId)
                    ) {
                        commit(
                            "UPDATE_SELECTED_PROFILE",
                            returnedProfileList.find(
                                (item) => item.id === alertId
                            )
                        );
                    } else {
                        commit(
                            "UPDATE_SELECTED_PROFILE",
                            returnedProfileList[0]
                        );
                    }
                } else {
                    commit("UPDATE_SELECTED_PROFILE", returnedProfileList[0]);
                }
            }
        });
    },
    putProfileAction({ commit }, data) {
        commit("UPDATE_LOADING", true);
        putPageProfile(data).then(() => {
            commit("CHANGE_UPDATE_STATUS", true);
            commit("UPDATE_LOADING", false);
        });
    },
    postProfileAction({ commit }, data) {
        commit("UPDATE_LOADING", true);
        postPageProfile(data).then(() => {
            commit("UPDATE_LAST_ADDITION", data.profile_name);
            commit("CHANGE_UPDATE_STATUS", true);
            commit("UPDATE_LOADING", false);
        });
    },
    deletePageProfileAction({ commit, state }, data) {
        deletePageProfile(data).then((res) => {
            if (res.status === 200) {
                const remaining = state.allProfile.filter(
                    (profile) => profile.id != data.id
                );
                if (remaining.length > 0) {
                    commit("UPDATE_ALL_PROFILE", remaining);
                    commit("UPDATE_SELECTED_PROFILE", remaining[0]);
                } else {
                    commit("UPDATE_ALL_PROFILE", [
                        {
                            id: 0,
                            text: "default",
                            unselected: [],
                            unselectedBooks: [],
                            settings: state.defaultSetting.settings,
                            positions: state.settings,
                        },
                    ]);
                    commit("UPDATE_SELECTED_PROFILE", {
                        id: 0,
                        text: "default",
                        unselected: state.defaultSetting.unselected,
                        settings: state.defaultSetting.settings,
                        unselectedBooks: state.defaultSetting.unselectedBooks,
                        positions: state.settings,
                    });
                }
            }
        });
    },
    getBooksPkAction({ commit }) {
        getBooksPk().then((res) => {
            let bookOptions = [];
            res.data.map((item) => {
                bookOptions.push(item.book_name);
                if (item.children) {
                    item.children.map((child) =>
                        bookOptions.push(child.book_name)
                    );
                }
            });
            commit("UPDATE_BOOKS", bookOptions);
        });
    },
    putUserProfileAction(_, params) {
        putUsers(params).then((res) => {});
    },
    updateAlertTutorialAction({ state }, data) {
        state.alertTutorial = data;
    },
    cleanUpProfileAction({ commit }) {
        state.cleanUpLoading = true;
        const params = {
            meta_value: "alert",
            value: state.defaultSetting,
        };
        putPageProfile(params).then(() => {
            state.cleanUpLoading = false;
            const snackbar = {
                message: "All profile column showing settings have been reset.",
                color: "green",
                btnName: "Close",
                status: true,
                timeout: 2000,
            };
            commit("UPDATE_SNACKBAR", snackbar, { root: true });
        });
    },
};

const mutations = {
    UPDATE_ALL_ALERT_OPTIONS(state, data) {
        state.allAlertOptions = data;
    },
    UPDATE_SELECTED_PROFILE(state, data) {
        if (localStorage.getItem("alertId") !== data.id) {
            localStorage.setItem("alertId", data.id);
        }
        state.selectedProfile = deepClone(data);
    },
    UPDATE_ALL_PROFILE(state, data) {
        localStorage.setItem("alertProfiles", JSON.stringify(data));
        state.allProfile = data;
        state.isBtnDisabled = false;
    },
    CHANGE_UPDATE_STATUS(state, data) {
        state.updated = data;
    },
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_BTN_STATUS(state, data) {
        state.isBtnDisabled = data;
    },
    UPDATE_CLICKED_OUTSIDE(state, data) {
        state.clickedOutside = data;
    },
    UPDATE_LAST_ADDITION(state, data) {
        state.lastAddition = data;
    },
    UPDATE_BOOKS(state, data) {
        state.books = data;
    },
    UPDATE_REFRESH_PERIOD(state, data) {
        state.selectedPeriod = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
